import ScrollUp from "./components/ScrollUp";
export default ScrollUp;
